export const TIMER_INTERVAL = 1000;

export const NO_REPETITIONS = 1;

export const FIELD_FOR_CHECK = {
  TYPE: 'type',
  VALUE: 'value',
}
